import CourseTable from '../components/CourseTable';

export default function Courses() {
  return (
    <main>
      <CourseTable />
    </main>
  );
}